const childrenResources = {
  en: {
    children: {
      title: 'Voluntary accident insurance for children',
      calculator: 'Insurance Calculator',
      'description.title': 'Description',
      'description.text1':
        'Childhood is almost always associated with a high risk of getting a variety of injuries. Due to the fact that children do not have sufficient life experience, while being extremely active, injuries occur quite often.\n' +
        '\n' +
        'Regardless of whether your child is studying at school or just getting ready for it, or may be he is chilling in a summer camp or visiting his grandmother, thanks to the insurance policy, you get a real opportunity to compensate for the costs of restoring the health of a child injured in an accident.\n',
      'description.text1.small':
        "Childhood is almost always associated with a high risk of getting a variety of injuries. Due to the fact that children do not have sufficient life experience, while being extremely active, injuries occur quite often. Children's accident insurance program is a solution for parents.",
      'description.text2': 'coverage 24 hours a day',
      'description.text3':
        'territory of insurance - the Republic of Kazakhstan, when insuring throughout the world, a multiplying coefficient is applied',
      'description.text4': 'age of children from 1 to 17 years old inclusive',
      'description.text5':
        'An insured event is an accident that led to the death of the Insured, the establishment of disability, temporary disorder of body functions.',
      'description.text6': 'The payout is set at:',
      'description.text7': 'Upon death 100% of the sum insured',
      'description.text8':
        'When establishing the category "a child with a disability" - 60% of the sum insured',
      'description.text9':
        'Upon receipt of an injury, injury - 0.2% of the sum insured for each day of illness, but not more than 30 (thirty) days for one insured event.',
      'health.programs': 'Health insurance programs',
      date: 'Contract start date',
      'Страхователь и застрахованный': 'Страхователь и застрахованный',
      Добавить: 'Добавить',
      'Период страхования': 'Период страхования',
      'Срок страхования': 'Срок страхования',
      'Территория страхования': 'Территория страхования',
      Премия: 'Премия',
      Рассчитать: 'Рассчитать',
      'Очистить расчет': 'Очистить расчет',
      'Добавить страхователя': 'Добавить страхователя',
      'Добавить застрахованных': 'Добавить застрахованных',
      ИИН: 'ИИН',
      'Он же застрахованный': 'Он же застрахованный',
      'Страховая сумма': 'Страховая сумма',
      Отмена: 'Отмена',
      'до 1 месяца включительно': 'до 1 месяца включительно',
      'от 1 до 2 месяцев включительно': 'от 1 до 2 месяцев включительно',
      'от 2 до 3 месяцев включительно': 'от 2 до 3 месяцев включительно',
      'от 3 до 4 месяцев включительно': 'от 3 до 4 месяцев включительно',
      'от 4 до 5 месяцев включительно': 'от 4 до 5 месяцев включительно',
      'от 5 до 6 месяцев включительно': 'от 5 до 6 месяцев включительно',
      'от 6 до 7 месяцев включительно': 'от 6 до 7 месяцев включительно',
      'от 7 до 8 месяцев включительно': 'от 7 до 8 месяцев включительно',
      'от 8 до 9 месяцев включительно': 'от 8 до 9 месяцев включительно',
      'от 9 до 10 месяцев включительно': 'от 9 до 10 месяцев включительно',
      'от 10 до 11 месяцев включительно': 'от 10 до 11 месяцев включительно',
      'от 11 до 12 месяцев включительно': 'от 11 до 12 месяцев включительно',
      'Весь мир': 'Весь мир',
      'Республика Казахстан': 'Республика Казахстан',
      'Тип клиента': 'Тип клиента',
      'Является выгодоприобретателем': 'Является выгодоприобретателем',
      Страхователь: 'Страхователь',
      Застрахованный: 'Застрахованный',
      Спорт: 'Спорт',
      'Не спорт': 'Не спорт',
      Отправить: 'Отправить',
      'Введите номер телефона страхователя':
        'Введите номер телефона страхователя',
      Продолжить: 'Продолжить',
      Закрыть: 'Закрыть',
      'Внесите необходимые корректировки': 'Внесите необходимые корректировки',
      'Ошибка валидации': 'Ошибка валидации',
      'Техническая ошибка': 'Техническая ошибка',
      'Попробуйте еще раз': 'Попробуйте еще раз',
      'Добавьте застрахованного': 'Добавьте застрахованного',
      'Добавьте страхователя': 'Добавьте страхователя',
      'Подтвердите согласие на сбор и обработку персональных данных':
        'Подтвердите согласие на сбор и обработку персональных данных',
    },
  },
  kz: {
    children: {
      title: 'Балаларды жазатайым оқиғалардан сақтандыру',
      calculator: 'Сақтандыру калькуляторы',
      'description.title': 'Сипаттамасы',
      'description.text1':
        'Балалық шақ әрдайым дерлік әртүрлі жарақат алу қаупін тудырады. Балалардың өмірлік тәжірибесі жеткіліксіз болғандықтан, олар өте белсенді болғандықтан, жарақаттар жиі кездеседі.\n' +
        '\n' +
        'Сіздің балаңыз мектепте оқып жүрсе де, әлде оған дайындалып жүрсе де, жазғы лагерьде жүрсе де, әлде әжесінің үйінде болса да, сақтандыру полисінің арқасында сіз жазатайым оқиғадан зардап шеккен баланың денсаулығын қалпына келтіру шығындарын өтеуге нақты мүмкіндік аласыз.',
      'description.text1.small':
        'Балалық шақ әрдайым дерлік әртүрлі жарақат алу қаупін тудырады. Балалардың өмірлік тәжірибесі жеткіліксіз болғандықтан, олар өте белсенді болғандықтан, жарақаттар жиі кездеседі. Балаларды жазатайым оқиғалардан сақтандыру бағдарламасы - ата-аналар үшін оң шешім.',
      'description.text2': 'қамту тәулігіне 24 сағат',
      'description.text3':
        'сақтандыру аумағы - Қазақстан Республикасы, бүкіл әлем аумағы бойынша сақтандыру кезінде арттыру коэффициенті қолданылады',
      'description.text4': 'балалардың жасы - 1 жастан 17 жасқа дейін',
      'description.text5':
        'Сақтандырылған адамның қайтыс болуына, мүгедектіктің белгіленуіне, дене функцияларының уақытша бұзылуына әкеп соққан жазатайым оқиға сақтандыру жағдайы болып табылады.',
      'description.text6': 'Төлем келесі мөлшерде белгіленеді:',
      'description.text7': 'Сақтандыру сомасының 100% қайтыс болған кезде',
      'description.text8':
        '"Мүгедектігі бар бала" санатын белгілеу кезінде - сақтандыру сомасының 60%',
      'description.text9':
        'Жарақат алған кезде - аурудың әрбір күні үшін сақтандыру сомасының 0,2%, бірақ бір сақтандыру жағдайы бойынша 30 (отыз) күннен аспайды.',
      'health.programs': 'Денсаулықты сақтандыру бағдарламалары',
      date: 'Шарттың басталатын күні',
      'Страхователь и застрахованный': 'Сақтанушы және сақтандырылған тұлға',
      Добавить: 'Қосу',
      'Период страхования': 'Сақтандыру кезеңі',
      'Срок страхования': 'Сақтандыру мерзімі',
      'Территория страхования': 'Сақтандыру аумағы',
      Премия: 'Сақтандыру сыйақысы',
      Рассчитать: 'Есептеу',
      'Очистить расчет': 'Есептеуді тазарту',
      'Добавить страхователя': 'Сақтанушыны қосу',
      'Добавить застрахованных': 'Сақтандырылғандарды қосу',
      ИИН: 'ЖСН',
      'Он же застрахованный': 'Ол сақтандырылған тұлға болып табылады',
      'Страховая сумма': 'Сақтандыру сомасы',
      Отмена: 'Бас тарту',
      'до 1 месяца включительно': '1 айға дейін (қоса алғанда)',
      'от 1 до 2 месяцев включительно': '1 айдан 2 айға дейін (қоса алғанда)',
      'от 2 до 3 месяцев включительно': '2 айдан 3 айға дейін (қоса алғанда)',
      'от 3 до 4 месяцев включительно': '3 айдан 4 айға дейін (қоса алғанда)',
      'от 4 до 5 месяцев включительно': '4 айдан 5 айға дейін (қоса алғанда)',
      'от 5 до 6 месяцев включительно': '5 айдан 6 айға дейін (қоса алғанда)',
      'от 6 до 7 месяцев включительно': '6 айдан 7 айға дейін (қоса алғанда)',
      'от 7 до 8 месяцев включительно': '7 айдан 8 айға дейін (қоса алғанда)',
      'от 8 до 9 месяцев включительно': '8 айдан 9 айға дейін (қоса алғанда)',
      'от 9 до 10 месяцев включительно': '9 айдан 10 айға дейін (қоса алғанда)',
      'от 10 до 11 месяцев включительно':
        '10 айдан 11 айға дейін (қоса алғанда)',
      'от 11 до 12 месяцев включительно':
        '11 айдан 12 айға дейін (қоса алғанда)',
      'Весь мир': 'Бүкіл әлем',
      'Республика Казахстан': 'Қазақстан Республикасы',
      'Тип клиента': 'Клиент түрі',
      'Является выгодоприобретателем': 'Бенефициар болып табылады',
      Страхователь: 'Сақтанушы',
      Застрахованный: 'Сақтандырылған',
      Спорт: 'Спорт',
      'Не спорт': 'Спорт емес',
      Отправить: 'Жіберу',
      'Введите номер телефона страхователя':
        'Сақтанушының телефон нөмірін енгізіңіз',
      Продолжить: 'Жалғастыру',
      Закрыть: 'Жабу',
      'Внесите необходимые корректировки': 'Қажетті түзетулерді енгізіңіз',
      'Ошибка валидации': 'Валидация қателігі',
      'Техническая ошибка': 'Техникалық қате',
      'Попробуйте еще раз': 'Тағы да көріңіз',
      'Добавьте застрахованного': 'Сақтандырылған тұлғаны қосыңыз',
      'Добавьте страхователя': 'Сақтанушыны қосыңыз',
      'Подтвердите согласие на сбор и обработку персональных данных':
        'Жеке деректерді жинауға және өңдеуге келісіміңізді растаңыз',
    },
  },
  ru: {
    children: {
      title: 'Добровольное страхование детей от несчастного случая',
      calculator: 'Калькулятор страхования',
      'description.title': 'Описание',
      'description.text1':
        'Детские годы почти всегда сопряжены с большим риском получения разнообразных травм. Ввиду того что дети не обладают достаточным жизненным опытом, при этом будучи чрезвычайно активными, травмы у них случаются довольно часто.\n' +
        '\n' +
        'Вне зависимости от того, учится ваш ребёнок в школе или только готовится к ней, отправился он в летний лагерь или поехал к бабушке, благодаря страховому полису вы получаете реальную возможность компенсировать расходы на восстановление здоровья ребёнка, пострадавшего в результате несчастного случая.',
      'description.text1.small':
        'Детские годы почти всегда сопряжены с большим риском получения разнообразных травм. Ввиду того что дети не обладают достаточным жизненным опытом, при этом будучи чрезвычайно активными, травмы у них случаются довольно часто. Программа страхования детей от несчастных случаев – решение для родителей.',
      'description.text2': 'покрытие 24 часа в сутки',
      'description.text3':
        'территория  страхования - Республика Казахстан, при страховании по территории весь мир, применяется  повышающий коэффициент',
      'description.text4': 'возраст детей от 1 до 17 лет включительно',
      'description.text5':
        'Страховым  случаем  является несчастный  случай, приведший к смерти Застрахованного, установлению инвалидности, временному расстройству функций организма.',
      'description.text6': 'Выплата устанавливается в размере:',
      'description.text7': 'При смерти 100% от страховой суммы',
      'description.text8':
        'При установлении категории «ребенок с инвалидностью» - 60% от страховой суммы',
      'description.text9':
        'При получении увечья, травмы - 0,2% от страховой суммы за каждый день болезни, но не более 30 (тридцати) дней по одному страховому случаю.',
      'health.programs': 'Программы страхования здоровья',
      date: 'Дата начала договора',
      'Страхователь и застрахованный': 'Страхователь и застрахованный',
      Добавить: 'Добавить',
      'Период страхования': 'Период страхования',
      'Срок страхования': 'Срок страхования',
      'Территория страхования': 'Территория страхования',
      Премия: 'Премия',
      Рассчитать: 'Рассчитать',
      'Очистить расчет': 'Очистить расчет',
      'Добавить страхователя': 'Добавить страхователя',
      'Добавить застрахованных': 'Добавить застрахованных',
      ИИН: 'ИИН',
      'Он же застрахованный': 'Он же застрахованный',
      'Страховая сумма': 'Страховая сумма',
      Отмена: 'Отмена',
      'до 1 месяца включительно': 'до 1 месяца включительно',
      'от 1 до 2 месяцев включительно': 'от 1 до 2 месяцев включительно',
      'от 2 до 3 месяцев включительно': 'от 2 до 3 месяцев включительно',
      'от 3 до 4 месяцев включительно': 'от 3 до 4 месяцев включительно',
      'от 4 до 5 месяцев включительно': 'от 4 до 5 месяцев включительно',
      'от 5 до 6 месяцев включительно': 'от 5 до 6 месяцев включительно',
      'от 6 до 7 месяцев включительно': 'от 6 до 7 месяцев включительно',
      'от 7 до 8 месяцев включительно': 'от 7 до 8 месяцев включительно',
      'от 8 до 9 месяцев включительно': 'от 8 до 9 месяцев включительно',
      'от 9 до 10 месяцев включительно': 'от 9 до 10 месяцев включительно',
      'от 10 до 11 месяцев включительно': 'от 10 до 11 месяцев включительно',
      'от 11 до 12 месяцев включительно': 'от 11 до 12 месяцев включительно',
      'Весь мир': 'Весь мир',
      'Республика Казахстан': 'Республика Казахстан',
      'Тип клиента': 'Тип клиента',
      'Является выгодоприобретателем': 'Является выгодоприобретателем',
      Страхователь: 'Страхователь',
      Застрахованный: 'Застрахованный',
      Спорт: 'Спорт',
      'Не спорт': 'Не спорт',
      Отправить: 'Отправить',
      'Введите номер телефона страхователя':
        'Введите номер телефона страхователя',
      Продолжить: 'Продолжить',
      Закрыть: 'Закрыть',
      'Внесите необходимые корректировки': 'Внесите необходимые корректировки',
      'Ошибка валидации': 'Ошибка валидации',
      'Техническая ошибка': 'Техническая ошибка',
      'Попробуйте еще раз': 'Попробуйте еще раз',
      'Добавьте застрахованного': 'Добавьте застрахованного',
      'Добавьте страхователя': 'Добавьте страхователя',
      'Подтвердите согласие на сбор и обработку персональных данных':
        'Подтвердите согласие на сбор и обработку персональных данных',
    },
  },
};

export default childrenResources;
